export const environment = {
  production: false,
  env: 'stg',
  version: 'stg-3ea584bc',
  feedbackDelay: 5000,
  api: 'https://stg.api.roz.copec.cl',
};
